export default __webpack_public_path__ + "b51a20b936a023fb7df507639e19f194.woff";